import React, { Component } from 'react'
import { connect } from 'react-redux'
import { TextInput } from '@minted/minted-components'
import { asyncFilterElements } from '../../store/actions'

class SearchBar extends Component {
  componentDidMount() {}
  componentDidUpdate() {
    //this.props.dispatch(waitAndPrint(searchText))
  }
  handleInputChange = e => {
    e.persist()
    const searchText = e.target.value

    this.props.dispatch(asyncFilterElements(searchText))
  }

  render() {
    return (
      <TextInput
        name="textValue"
        label="Search"
        value={this.props.searchText}
        handleChange={this.handleInputChange}
      />
    )
  }
}

function mapStateToProps(state, ownProps) {
  return {
    searchText: state.dataDirectory.searchText,
    ...ownProps,
  }
}
//export default SearchBar
export default connect(mapStateToProps)(SearchBar)
